<ng-template #navItemContent let-firstLevel="firstLevel">
  <span class="nav-item-content">
    @if (firstLevel.icon; as icon) {
      <ui-icon [faName]="icon.name" [faStyle]="icon.family" />
    }
    <span class="nav-item-label">{{ firstLevel.label }}</span>
  </span>
</ng-template>

<ng-template #navItem let-firstLevel="firstLevel" let-defaultItem="defaultItem">
  @if (firstLevel.url) {
    <a
      uiNavLink
      [link]="firstLevel"
      [class.default-menu-item]="defaultItem"
      mat-button
      [disableRipple]="true"
    >
      <ng-container *ngTemplateOutlet="navItemContent; context: { firstLevel }" />
    </a>
  } @else {
    <button
      type="button"
      [class.default-menu-item]="defaultItem"
      mat-button
      [disableRipple]="true"
    >
      <ng-container *ngTemplateOutlet="navItemContent; context: { firstLevel }" />
    </button>
  }
</ng-template>

@if (items().length) {
  <nav class="container">
    @for (firstLevel of items(); track firstLevel; let first = $first) {
      @if (!firstLevel?.children?.length) {
        <ng-container *ngTemplateOutlet="navItem; context: { firstLevel, defaultItem: true }" />
      } @else {
        <ui-hover-menu [navItems]="firstLevel.children!">
          <ng-container *ngTemplateOutlet="navItem; context: { firstLevel, defaultItem: !first }" />
        </ui-hover-menu>
      }
    }
  </nav>
}
